import { RouteConstants } from '@/features/router/RouteConstants';

export type CampaignsChannelTabId = 'whatsapp' | 'sms' | 'email';

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getCampaignsChannelTabFromPathname = (pathname: string): CampaignsChannelTabId | undefined => {
  const prefix = escapeRegExp(RouteConstants.campaigns);
  const match = pathname.match(new RegExp(`^${prefix}/(whatsapp|sms|email)(/|$)`));
  return match?.[1] as CampaignsChannelTabId | undefined;
};
